<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype1-hotoke(v-if="show(1,null,true)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype1-season1(v-if="show(1,1,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype1-season2(v-if="show(1,2,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype1-season3(v-if="show(1,3,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype1-season4(v-if="show(1,4,false)")


transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype2-hotoke(v-if="show(2,null,true)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype2-season1(v-if="show(2,1,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype2-season2(v-if="show(2,2,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype2-season3(v-if="show(2,3,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype2-season4(v-if="show(2,4,false)")


transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype3-hotoke(v-if="show(3,null,true)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype3-season1(v-if="show(3,1,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype3-season2(v-if="show(3,2,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype3-season3(v-if="show(3,3,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype3-season4(v-if="show(3,4,false)")


transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype4-hotoke(v-if="show(4,null,true)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype4-season1(v-if="show(4,1,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype4-season2(v-if="show(4,2,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype4-season3(v-if="show(4,3,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype4-season4(v-if="show(4,4,false)")


transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype5-hotoke(v-if="show(5,null,true)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype5-season1(v-if="show(5,1,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype5-season2(v-if="show(5,2,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype5-season3(v-if="show(5,3,false)")
transition(@enter="enter" @leave="leave")
  .l-map-bg.maptype5-season4(v-if="show(5,4,false)")

</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-bg
  pos(-950px,-775px)
  wh(1900px,1550px)
  background-position center center
  background-repeat no-repeat
  +pc()
    for n in (1..5)
      &.maptype{n}-hotoke
        background-image url('/static/bg/bg-maptype'+(n)+'-hotoke-pc.jpg')
      &.maptype{n}-season1
        background-image url('/static/bg/bg-maptype'+(n)+'-season1-pc.jpg')
      &.maptype{n}-season2
        background-image url('/static/bg/bg-maptype'+(n)+'-season2-pc.jpg')
      &.maptype{n}-season3
        background-image url('/static/bg/bg-maptype'+(n)+'-season3-pc.jpg')
      &.maptype{n}-season4
        background-image url('/static/bg/bg-maptype'+(n)+'-season4-pc.jpg')
  +sp()
    for n in (1..5)
      &.maptype{n}-hotoke
        background-image url('/static/bg/bg-maptype'+(n)+'-hotoke-sp.jpg')
      &.maptype{n}-season1
        background-image url('/static/bg/bg-maptype'+(n)+'-season1-sp.jpg')
      &.maptype{n}-season2
        background-image url('/static/bg/bg-maptype'+(n)+'-season2-sp.jpg')
      &.maptype{n}-season3
        background-image url('/static/bg/bg-maptype'+(n)+'-season3-sp.jpg')
      &.maptype{n}-season4
        background-image url('/static/bg/bg-maptype'+(n)+'-season4-sp.jpg')
</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted,computed,reactive} from "vue"
import { useStore } from '@/store'

export default defineComponent({
  name:'MapBg',

  props:{
    maptype:{
      type:Number,
      default: 1
    },
    mapdata:{
      type:Object,
      default: function() {
        return {}
      }
    }
  },

  setup(props, context) {
    const store = useStore()
    const oldState = reactive({
      maptype:store.ui.state.maptype,
      hotoke:store.ui.state.hotoke,
      season:store.ui.state.season,
    })
    const show = computed(()=>{
      return (maptype,season,hotoke)=>{
        if(store.ui.state.maptype != maptype){
          return false
        }
        if(store.ui.state.hotoke){
          //仏
          if(hotoke){
            return true
          } else {
            return false
          }
        } else {
          //季節
          if(store.ui.state.season == season){
            return true
          } else {
            return false
          }
        }
      }
    })
    
    const enter = (el, done)=> {
      if(oldState.season != store.ui.state.season || oldState.hotoke != store.ui.state.hotoke){
        $(el).css({opacity:0})
        store.ui.state.kumoMotion = 1
        let delay = store.ui.state.kumoMotionDurationAll/1000
        gsap.to(
          el,
          {opacity:1,duration:0.1,delay:delay,onComplete:()=>{
            store.ui.state.kumoMotion = 2
            done()
          }}
        )
      } else {
        done()
      }

      oldState.maptype = store.ui.state.maptype
      oldState.hotoke = store.ui.state.hotoke
      oldState.season = store.ui.state.season
    }
    const leave = (el, done)=> {
      if(oldState.season != store.ui.state.season || oldState.hotoke != store.ui.state.hotoke){
        let delay = store.ui.state.kumoMotionDurationAll/1000
        gsap.to(
          el,
          {opacity:0,duration:0.1,delay:delay,onComplete:()=>{
            done()
          }}
        )
      } else {
        done()
      }
    }

    onMounted(()=>{
    })

    return{
      show,
      enter,
      leave
    }
  }
})
</script>
